import axios from "@/api/axios";

const getNomenclature = (data) => {
    return axios
        .post('/admin/nomenclature/get-nomenclature', {nomenclature: data})
        .then(response => response.data)
}

const getOnlineGroups = (data) => {
    return axios
        .post('/admin/nomenclature/online-groups', {nomenclature: data})
        .then(response => response.data)
}

const saveNomenclature = (data) => {
    return axios
        .post('/admin/nomenclature/save-nomenclature', {nomenclature: data})
        .then(response => response.data)
}

//--------------------------------------------------------------------------------------

const getNomenclatureSegments = (data) => {
    return axios
        .post('/admin/nomenclature/nomenclature-segments', {nomenclature: data})
        .then(response => response.data)
}

const createNomenclatureSegments = (data) => {
    return axios
        .post('/admin/nomenclature/nomenclature-segments-create', {nomenclature: data})
        .then(response => response.data)
}

const getNomenclatureSegmentsUnit = (data) => {
    return axios
        .post('/admin/nomenclature/nomenclature-segments-unit', {nomenclature: data})
        .then(response => response.data)
}

const createNomenclatureSegmentsUnit = (data) => {
    return axios
        .post('/admin/nomenclature/nomenclature-segments-create-unit', {nomenclature: data})
        .then(response => response.data)
}

const checkDataMark = (data) => {
    return axios
        .post('/admin/nomenclature/marking-code-check', { nomenclature: data })
        .then(response => response.data)
}

export default {
    getNomenclature,
    getOnlineGroups,
    saveNomenclature,
    getNomenclatureSegments,
    createNomenclatureSegments,
    getNomenclatureSegmentsUnit,
    createNomenclatureSegmentsUnit,
    checkDataMark
}